import FetcherInput from "../../_shared/Fetcher/FetcherInput";
import IAdmissionRepository from "../4_Repositories/IAdmissionRepository";
import { quizzesEntity, summaryEntity } from "../2_Entities";
import { formatDatesValueObject } from "../3_ValuesObjects";
import { IParamsSendQuestions } from "../2_Entities/SendQuestions";

export default class HTTPAdmissionRepository implements IAdmissionRepository {
  private readonly _fetcher: FetcherInput;

  constructor(fetcher: FetcherInput) {
    this._fetcher = fetcher;
  }

  public async getQuizzes(admissionExamId: string, quizzesId: string) {
    const { data } = await this._fetcher.request.get(
      `/admission/candidate/admission-exams/${admissionExamId}/quizzes/${quizzesId}`
    );
    return quizzesEntity({ ...data.data });
  }

  public async getSummary(): Promise<ReturnType<typeof summaryEntity>> {
    const { data } = await this._fetcher.request.get(
      `/admission/candidate/admission-exam/resume`
    );

    return summaryEntity({
      ...data.data,
      availableFrom: formatDatesValueObject(data.data.availableFrom),
    });
  }

  public async postStart<T>(
    admissionExamId: string,
    quizzesId: string
  ): Promise<T> {
    const { data } = await this._fetcher.request.post(
      `/admission/candidate/admission-exams/${admissionExamId}/quizzes/${quizzesId}/start`
    );
    return data as T;
  }

  public async sendQuestion<T>(
    admissionExamId: string,
    quizzesId: string,
    params: IParamsSendQuestions
  ): Promise<T> {
    const { data } = await this._fetcher.request.post(
      `/admission/candidate/admission-exams/${admissionExamId}/quizzes/${quizzesId}/send-answer`,
      params
    );
    return data as T;
  }
}
